import script from "./DropDownMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropDownMenu.vue?vue&type=script&lang=ts&setup=true"

import "./DropDownMenu.vue?vue&type=style&index=0&id=7524ef32&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7524ef32"]])

export default __exports__